import * as React from "react";
import {
    Button,
    FormGroup,
    Grid,
    Switch,
    TextField,
    FormControlLabel, FormControl, InputLabel, Select, MenuItem
} from "@material-ui/core";
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    createAutoRefillOrderRequestDefault,
    ICreateAutoRefillOrderRequest
} from "./request/CreateAutoRefillOrderRequest";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: ICreateAutoRefillOrderRequest
    response: any
    isDrugAsin: boolean
}

enum InputField {
    DRUG_ID,
    FULFILLABLE_PRODUCT_ASIN,
    PRESCRIPTION_ID,
    PROFILE_ID,
    DAYS_SUPPLY
}

class CreateAutoRefillOrderSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: createAutoRefillOrderRequestDefault,
            request: { eventType: 'DRUG_FILLABLE' } as ICreateAutoRefillOrderRequest,
            response: '',
            isDrugAsin: false
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setEventType = this.setEventType.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleIsDrugAsin = this.toggleIsDrugAsin.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>

                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id"
                                variant="outlined"
                                value={ this.state.request.drugId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <FormControl>
                                <InputLabel>Event Type</InputLabel>
                                <Select
                                    value={ this.state.request.eventType || 'DRUG_FILLABLE' }
                                    style={{width: 400}}
                                    onChange={ this.setEventType }
                                >
                                    <MenuItem value="DRUG_FILLABLE">
                                        <em>DRUG_FILLABLE</em>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Fulfillable Product Asin"
                                variant="outlined"
                                disabled={ this.state.isDrugAsin }
                                value={ this.state.request.fulfillableProductAsin || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.FULFILLABLE_PRODUCT_ASIN, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Prescription Id"
                                variant="outlined"
                                value={ this.state.request.prescriptionId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PRESCRIPTION_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Days Supply (Optional)"
                                variant="outlined"
                                value={ this.state.request.daysSupply || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DAYS_SUPPLY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <FormGroup>
                                <FormControlLabel 
                                    control={ <Switch checked={ this.state.isDrugAsin } onChange={ this.toggleIsDrugAsin }/> } 
                                    label="Is Drug Asin" 
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Create Auto Refill Order Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Create Auto Refill Order
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private toggleIsDrugAsin() {
        this.setState({ isDrugAsin: !this.state.isDrugAsin });
    }

    private setEventType(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: ICreateAutoRefillOrderRequest = this.state.request;
        updatedRequest.eventType = event.target.value
        this.setState({ request: updatedRequest });
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: ICreateAutoRefillOrderRequest = this.state.request;

        switch (field) {
            case InputField.DRUG_ID: {
                updatedRequest.drugId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.FULFILLABLE_PRODUCT_ASIN: {
                updatedRequest.fulfillableProductAsin = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PRESCRIPTION_ID: {
                updatedRequest.prescriptionId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.DAYS_SUPPLY: {
                updatedRequest.daysSupply = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: ICreateAutoRefillOrderRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
        } else {
            body = { ...this.state.request };
            if (this.state.isDrugAsin) {
                body.drugAsin = true;
            }
        }

        const config = {
            body,
            headers: {}
        }

        this.callCreateAutoRefillOrder(config);

        this.setState({ isLoading: false });
    }

    private callCreateAutoRefillOrder(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/auto-refill/order';

        console.log(config)
        API.post(apiName, path, config).then((createAutoRefillOrderResponse: any) => {
            console.log(createAutoRefillOrderResponse);

            this.setState({ response: createAutoRefillOrderResponse });
        }).catch((error) => {
            console.log(error);

            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default CreateAutoRefillOrderSection;
